import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-back",
  "use": "ico-back-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-back\">\n<path d=\"M4.20996 8L5.70996 9L11.571 3.04756L10.1567 1.63331L4.20996 8Z\" fill=\"#3B4153\" />\n<path d=\"M4.21008 7.99988L10.1625 14.3666L11.5771 12.952L5.71008 6.49988L4.21008 7.99988Z\" fill=\"#3B4153\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol